import { ReactComponent as RepeatIcon } from 'resources/images/lyrics.svg';
import { Icon } from '@chakra-ui/react';
import { routes } from 'app/routing/routesConfig';
import { useParams } from 'react-router-dom';
import { useAppSelector } from 'app/store';
import {
  getSharedAudioLyricsLink,
  getSharedPlaylist,
} from 'app/store/Shares/selectors';
import { LinkWithActiveState } from '../LinkWithActiveState';

export const LyricsButton = () => {
  const { shareToken } = useParams();
  const to = shareToken
    ? routes.sharesPlayLyrics.path.replace(':shareToken', shareToken || '')
    : routes.playerLyrics.path;

  const sharedPlaylist = useAppSelector(getSharedPlaylist);
  const showLyricsFlag = useAppSelector(getSharedAudioLyricsLink);
  const hideLyrics = sharedPlaylist && !showLyricsFlag;

  if (hideLyrics) {
    return null;
  }

  return (
    <LinkWithActiveState to={to}>
      <Icon as={RepeatIcon} w={4} h={4} data-testid="audio-lyrics-button" />
    </LinkWithActiveState>
  );
};
